/**
 * getIsServiceValid
 *
 * @description
 * Validate service by checking if the given URL, preview state, and ID are valid.
 * @param {SelectedNewsSource} source - The news source object containing URL, preview validity, and ID.
 * @param {string[]} [sourcesIds] - An optional array of valid source IDs to check against.
 * @returns {boolean} - If true, the service is considered valid; otherwise, false.
 *
 */
const getIsServiceValid = (source, sourcesIds) => {
    // If there's a URL and (preview is valid or there's an ID) or no URL,
    // return true (service valid); otherwise, return false (service invalid)
    return ((source.url &&
        Boolean(source.isPreviewValid || sourcesIds?.includes(source.id))) ||
        !source.url);
};
export default getIsServiceValid;
